import React from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

/**
 * Single desktop nav item — handles 3 cases: dropdown trigger, internal page link,
 * and in-page anchor link.
 */
const DesktopNavItem = ({ link, isOpen, onOpen, onClose, onAnchor, onPage }) => {
  const location = useLocation();
  const isPageActive = link.isPage && location.pathname === link.href;
  const isHighlighted = link.label === 'Resources';

  return (
    <div className="relative group" onMouseEnter={onOpen} onMouseLeave={onClose}>
      {link.children ? (
        <button
          type="button"
          className="flex items-center gap-1 px-3 py-2 text-sm font-medium whitespace-nowrap text-gray-700 hover:text-[#00BCE4] transition-colors duration-300"
          style={{ fontFamily: 'Inter, sans-serif' }}
          onClick={() => onAnchor(link.href)}
        >
          {link.label}
          <ChevronDown size={14} className="transition-transform duration-300 group-hover:rotate-180" />
        </button>
      ) : link.isPage ? (
        <a
          href={link.href}
          onClick={(e) => { e.preventDefault(); onPage(link.href); }}
          className={`px-3 py-2 text-sm font-medium whitespace-nowrap transition-colors duration-300 ${
            isPageActive ? 'text-[#00BCE4]' : 'text-gray-700 hover:text-[#00BCE4]'
          }`}
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          {link.label}
        </a>
      ) : (
        <a
          href={link.href}
          onClick={(e) => { e.preventDefault(); onAnchor(link.href); }}
          className={`px-3 py-2 text-sm font-medium whitespace-nowrap transition-colors duration-300 ${
            isHighlighted ? 'text-[#00BCE4]' : 'text-gray-700 hover:text-[#00BCE4]'
          }`}
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          {link.label}
        </a>
      )}

      {link.children && (
        <div
          className={`absolute top-full left-0 w-64 bg-white rounded-lg shadow-xl border border-gray-100 py-2 transition-all duration-300 ${
            isOpen ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2'
          }`}
          style={{ zIndex: 100 }}
        >
          {link.children.map((child) => (
            <a
              key={child.label}
              href={child.href}
              onClick={(e) => { e.preventDefault(); child.isPage ? onPage(child.href) : onAnchor(child.href); }}
              className="block px-5 py-2.5 text-sm text-gray-600 hover:text-[#00BCE4] hover:bg-gray-50 transition-colors duration-200"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default DesktopNavItem;
